import { ReactNode } from 'react';
import Text from '~/components/Text';
import CloseButton from '~/components/CloseButton';
import Gap from '~/components/Gap';

interface IModalHeaderProps {
  headerJsx: ReactNode;
  handleClose(): void;
}

const ModalHeader = ({ headerJsx, handleClose }: IModalHeaderProps) => (
  <>
    <div className="spread full-width">
      <Text className="full-width semi-bold">{typeof headerJsx !== 'undefined' && headerJsx}</Text>
      <CloseButton onClose={handleClose} />
    </div>
    <Gap t={12} />
  </>
);

export default ModalHeader;
